import type { BaseButtonProps } from './types.js';

export const SPINNER_SIZES: Record<NonNullable<BaseButtonProps['size']>, string> = {
  small: '24px',
  medium: '24px',
  large: '32px',
};
